import { Injectable } from '@angular/core';
import { BaseHttpApiService } from './base-http.service';
import { HttpClient } from '@angular/common/http';
import { DateFormatHelperService } from './date-format-helper.service';
import { MorayWestInstructionsGridDTO } from '../Dtos/moray-west/instructions-grid-dto';
import { Observable, of } from 'rxjs';
import { MorayWestInstructionDTO } from '../Dtos/moray-west/instructions-dto';

@Injectable({
  providedIn: 'root'
})
export class MorayWestService extends BaseHttpApiService {

  constructor(private httpClient: HttpClient,
    private dateHelper: DateFormatHelperService) { super(); }

  GetActiveAndFutureInstructions(): Observable<MorayWestInstructionsGridDTO[]> {
    return this.httpClient.get<MorayWestInstructionsGridDTO[]>(`${this.apiURL}MorayWest/Instructions`);
  }

  GetInstructionsByDateRange(from: Date, to: Date): Observable<MorayWestInstructionsGridDTO[]> {
    from.setHours(0, 0, 0, 0); // Set time to 00:00
    to.setHours(23, 59, 59, 999); // Set time to 23:59
    return this.httpClient.get<MorayWestInstructionsGridDTO[]>(`${this.apiURL}MorayWest/Instructions/${this.dateHelper.GetAPIFormat(from)}/${this.dateHelper.GetAPIFormat(to)}`);
  }

  GetInstructionById(instructionId: number | string): Observable<MorayWestInstructionDTO> {
    return this.httpClient.get<MorayWestInstructionDTO>(`${this.apiURL}MorayWest/${instructionId}`)
  }

  SaveInstruction(instruction: MorayWestInstructionDTO) {
    if (typeof instruction.issuedFrom === 'string') {
      instruction.issuedFrom = new Date(instruction.issuedFrom);
    }
    instruction.issuedFrom.setUTCHours(0, 0, 0, 0); // Set time to 00:00 GMT
    debugger;
    if (instruction.issuedTo) {
      if (typeof instruction.issuedTo === 'string') {
        instruction.issuedTo = new Date(instruction.issuedTo);
      }
      instruction.issuedTo.setUTCHours(23, 59, 59, 999);
    } // Set time to 23:59
    return this.httpClient.post<object>(`${this.apiURL}MorayWest`, instruction);
  }

  ChangeStatus(instructionId: number | string, status: string) {
    return this.httpClient.put<object>(`${this.apiURL}MorayWest/SetStatus?instructionId=${instructionId}&status=${status}`, '')
  }

  ApplyToEDT(instructionId: string | number) {
    return this.httpClient.put<object>(`${this.apiURL}MorayWest/ApplyToEDT?instructionId=${instructionId}`, '')
  }
}
